import { Component } from "./scroll-navigation-menu";

export default function DemoScrollNavigationMenu() {
  return <Component />;
}
